class AuthWithConnectionCtrl {
  constructor(ENVIRONMENT, PROVIDERS, AuthService, FlashService, $window, $stateParams, $state, $scope) {
    'ngInject';
    this.AuthService = AuthService;
    this.FlashService = FlashService;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$scope = $scope;
    this.$window = $window;
    this.PROVIDERS = PROVIDERS;
    this.ENVIRONMENT = ENVIRONMENT;
    this.errorMessage = null;
    this.loading = true;
  }

  async $onInit() {
    try {

      await this.AuthService.logout(true);

      // DB page magic link carries a one-time code only (never the connection).
      const code = this.$stateParams.code;
      if (!code) {
        throw new Error('This sign-in link is invalid or has expired. Please open it again.');
      }

      try {
        await this.AuthService.loginWithHandoff(code);
      }
      catch (logErr) {
        throw new Error(logErr?.details?.validationErrorMessage || logErr.message || 'Cannot log in. Please open the link again.');
      }

      this.FlashService.success("Logged in successfully.");
      const target = this.$stateParams.authRedirect && this.resolveRedirect(this.$stateParams.authRedirect);
      if (!target) {
        if (this.$stateParams.authRedirect) this.FlashService.warning("The link's redirect address is not allowed.");
        this.$state.go("app.form-builder", {});
        return;
      }

      if (target.isFunction) {
        // The function swaps this one-time code for the session's connection.
        const fnName = target.url.pathname.split('/').filter(Boolean).pop();
        const accessCode = await this.AuthService.issueFunctionAccessCode(fnName);
        target.url.searchParams.delete('connection');
        target.url.searchParams.set('authCode', accessCode);
        this.loading = "";
      }
      this.$window.location.replace(target.url.toString());

    } catch (error) {

      this.loading = false;
      this.errorMessage = error.message;
      this.$scope.$apply();
    }
  }

  // Post-login redirects may only go to this web app or to our functions host,
  // over https (http only on localhost). Anything else (another site, javascript:,
  // data:) is refused so a crafted DB page link cannot redirect or run script.
  resolveRedirect(rawRedirect) {
    let url;
    try {
      url = new URL(decodeURIComponent(rawRedirect));
    } catch (e) {
      return null;
    }
    const isLocal = url.hostname === 'localhost' || url.hostname === '127.0.0.1';
    if (url.protocol !== 'https:' && !(isLocal && url.protocol === 'http:')) return null;

    const { functionsBaseUrl, localPort } = this.ENVIRONMENT.firebase;
    const functionOrigins = [];
    if (functionsBaseUrl) functionOrigins.push(new URL(functionsBaseUrl).origin);
    if (localPort) functionOrigins.push(`http://localhost:${localPort}`, `http://127.0.0.1:${localPort}`);

    if (functionOrigins.includes(url.origin)) return { url, isFunction: true };
    if (url.origin === this.$window.location.origin) return { url, isFunction: false };
    return null;
  }
}

export default {
  bindings: {
  },
  templateUrl: "user/auth-with-connection/auth-with-connection.component.html",
  controller: AuthWithConnectionCtrl
}
